<script lang="ts">
	import CarouselArrows from "@components/CarouselArrows.svelte";
	import LinkCard from "@components/LinkCard.svelte";
	import Carousel from "@components/common/Carousel.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Link from "@components/common/Link.svelte";
	import { ButtonVariant } from "@components/common/getButtonClass.js";
	import type { EmblaCarouselType } from "embla-carousel";
	import arrowNext from "@core/assets/icons/arrow-next.svg?raw";
	import { getClientsPath } from "@core/schema/paths/getClientsPath.js";
	import { getConnectWithFastestPath } from "@core/schema/paths/getConnectWithFastestPath.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import { getIndustries } from "../data/getIndustries.js";

	const { tenant } = getGlobalTemplateProps();
	const industries = getIndustries(tenant).filter(({ show }) => show === true);
	let api = $state<EmblaCarouselType>();
</script>

{#if industries.length > 1}
	<div class="full-width pb-24 xl:pb-28 flex flex-col gap-4">
		<Carousel
			options={{
				loop: false,
			}}
			bind:api
			items={industries}
		>
			{#snippet item({ title, iconName, href })}
				<div
					class="shrink-0 basis-60 sm:basis-64 md:basis-68 lg:basis-72 first:ml-[calc((100%-var(--container-width))/2)] last:mr-[calc((100%-var(--container-width))/2)]"
				>
					<LinkCard className="h-full" {title} {iconName} {href} />
				</div>
			{/snippet}
		</Carousel>
		<div class="flex flex-col gap-4">
			<CarouselArrows {api} slideCount={industries.length} />
			<div class="flex flex-col gap-3 mt-8">
				<Link
					variant={ButtonVariant.Phlox}
					class="mx-auto flex items-center justify-center"
					href={getConnectWithFastestPath(tenant)}
					>Chci fastest služby
					<Icon icon={arrowNext} class="ml-2 text-fstgrey-900"></Icon>
				</Link>
				<Link
					variant={ButtonVariant.GreenOutlineLightBg}
					class="mx-auto flex items-center justify-center"
					href={getClientsPath(tenant)}>Komu jsme pomohli</Link
				>
			</div>
		</div>
	</div>
{/if}
